export default __webpack_public_path__ + "static/media/golfer.2a1dea45.png";